import { EntityRequestLoa } from "../../entity/EntityRequestLoa";

export class DtoRequestLoasPostRes extends EntityRequestLoa {}
